import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {PageBody, PageContent, PageWrapper} from '@/components/ui/page-atoms/PageAtoms'
import {SettingsSidebar} from '@/components/commons/settings-sidebar/SettingsSidebar'
import {Outlet} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const MailerRoute = () => {
    const permissions = usePermissions()

    if (!permissions?.settings?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageWrapper style={{overflow: 'hidden'}}>
            <SettingsSidebar />
            <PageBody>
                <Header />
                <Divider direction="horizontal" />
                <PageContent>
                    <Outlet />
                </PageContent>
            </PageBody>
        </PageWrapper>
    )
}
